import { InjectionKey } from 'vue'
import { Store, useStore } from 'vuex'
import { RootState } from '@/app/providers/store/types/RootState'

export const storeKey: InjectionKey<Store<RootState>> = Symbol()

export const useAppStore = (): Store<RootState> => useStore(storeKey)